import { Component, OnInit } from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { TableAction } from '../../../dto/util/table-action';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { UsuarioPersonaDto } from '../../../dto/usuario/usuario-persona.dto';
import { PermisosExpedienteService } from '../../../services/permisos-expediente.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { combineLatest } from 'rxjs';
import { Constants } from '../../../constants/constants';
import { UserDataDto } from '../../../dto/auth/user-data.dto';

@Component({
  selector: 'app-gestion-permisos-expediente',
  templateUrl: './gestion-permisos-expediente.component.html',
  styleUrl: './gestion-permisos-expediente.component.scss'
})
export class GestionPermisosExpedienteComponent implements OnInit {

  title = ""

  idUsuarioBusqueda?: number
  habilitarBotonPermisos = false
  submitButton = ""
  permisosButton = ""
  usuarioBusqueda?: UsuarioPersonaDto
  tableText: any = {};
  formsText: any = {};
  idExpediente?: number
  usuariosAsignados: any[] = []
  columns: TableColumn[] = [];
  actions: TableAction[] = [];
  fieldsGestionPermisos: FormField[] = [];
  fieldsInfoUsuarioBusqueda: FormField[] = [];
  fieldsBusquedaPorCedula: FormField[] = [];
  fieldsGestionPermisosFormGroup?: FormGroup;
  fieldsInfoUsuarioBusquedaFormGroup?: FormGroup;
  fieldsBusquedaPorCedulaFormGroup?: FormGroup;
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  expediente:string='';
  radicado?:string;
  private userData: UserDataDto = {};
  constructor(
    private readonly route: ActivatedRoute,
    private readonly permisosExpedienteService: PermisosExpedienteService,
    private readonly alertamodalService: AlertaModalService,
    private readonly translate: TranslateService,
  ){
    this.route.params.subscribe(params => {
      this.idExpediente = params['idExpediente'];
      this.radicado = params['radicado'];
    });
    combineLatest({
      tabla: this.translate.stream('gestion-permisos-expedientes-tabla'),
      formulario: this.translate.stream('gestion-permisos-expedientes-formularios')
    }).subscribe(({tabla, formulario})=>{
      this.formsText = formulario
      this.tableText = tabla
      this.title = formulario['titulo']
      this.submitButton = formulario['boton-buscar']
      this.permisosButton = formulario['boton-permisos']
      this.ngOnInit();
      this.inicializarColumnas();
    })

  }

  ngOnInit(): void {
    this.expediente = this.radicado!.toString();
    this.creacionFormulario();
    this.consultarUsuarioAsignados();
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
  }

  creacionFormulario(){
    this.fieldsBusquedaPorCedula = [
      {
        name: 'document',
        label: this.formsText['cedula'],
        type: 'text',
        placeholder: this.formsText['placeholder-cedula'],
        required: true,
        width: '12',
        visible: true,
        validation: [Validators.minLength(5), Validators.maxLength(15)],
        errorMessages: {
          required: this.formsText['cedula-requerida'],
          minlength: this.formsText['cedula-min-lenght'],
          maxlength: this.formsText['cedula-max-lenght'],
        },
      },

    ]

    this.fieldsInfoUsuarioBusqueda = [
      {
        name: 'nombreCompleto',
        label: this.formsText['nombre-completo'],
        type: 'text',
        required: false,
        width: '6',
        visible: true,
        disabled: true,
      },
      {
        name: 'correoElectronico',
        label: this.formsText['correo-electronico'],
        type: 'text',
        required: false,
        width: '6',
        visible: true,
        disabled: true
      },
    ]

    this.fieldsGestionPermisos =[
      {
        name: 'estado',
        label: this.formsText['estado'],
        type: 'select',
        required: true,
        width: '6',
        options: [
          { Id: 1, Nombre: 'Activo' },
          { Id: 0, Nombre: 'Inactivo' },
        ],
        validation: [Validators.required],
        errorMessages: {
          required: 'Campo estado es requerido',
        },
      },
    ]
  }

  onSubmitBuscarUsuario(event: FormGroup){
    this.fieldsBusquedaPorCedulaFormGroup = event
    this.idUsuarioBusqueda = event.value.document
    this.permisosExpedienteService.consultarUsuarioIdentificacion(event.value.document, this.idExpediente!)
      .subscribe({
      next: resp => {
        this.idUsuarioBusqueda = resp.data.Persona.Id_Usuario
        this.usuarioBusqueda = resp
        const nombreCompleto = this.fieldsInfoUsuarioBusqueda.find(
          item => item.name == 'nombreCompleto'
        )
        const correoElectronico = this.fieldsInfoUsuarioBusqueda.find(
          item => item.name == 'correoElectronico'
        )
        if (nombreCompleto != undefined && correoElectronico != undefined) {

          const { Primer_nombre, Segundo_nombre, Primer_apellido, Segundo_apellido } = resp.data;

          nombreCompleto.placeholder = [Primer_nombre, Segundo_nombre, Primer_apellido, Segundo_apellido]
           .filter(name => name) // Filtra valores nulos o indefinidos
           .join(" "); // Une los valores con espacio

          correoElectronico.placeholder = resp.data.Persona.Correo_electronico
          this.habilitarBotonPermisos = true;
        }

      },
      error: ()=>{
        this.alertamodalService.alertaAccion("error", "Error buscando usuario", "Usuario no encontrado o ya asignado al expediente ", () =>{
          this.clearForms()
        }, () =>{
          this.clearForms()
        })
      }
    })
  }

  inicializarColumnas(){
    this.columns = [
      {
        field: 'idPermiso',
        title: 'id',
        type: 'text',
        visible: false,
        filterable: false,
        sortable: false
      },
      {
        field: 'nombreCompleto',
        title: this.tableText['nombre-usuario'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        field: 'identificacion',
        title: this.tableText['identificacion'],
        type: 'text',
        filterable: false,
        sortable: false
      },
      {
        field: 'correoElectronico',
        title: this.tableText['correo-electronico'],
        type: 'text',
        filterable: false,
        sortable: false
      },
      {
        field: 'estado',
        title: this.tableText['estado'],
        type: 'inputselect',
        filterable: false,
        sortable: false,
        elements: [
          {id: true, nombre: 'Acceso'},
          {id: false, nombre: 'Sin acceso'},
        ],
        option: 'nombre',
        value: 'id',
        accion: item => {
          this.permisos(item, false);
        },
        enabledAction: 'true'
      }
    ]
    // this.actions = [
    //   {
    //     type: 'check',
    //     idAccion: "permisos",
    //     selectField: "estado"
    //   }
    // ]
  }

  permisos(item: any, eventoAccion: boolean){
    if (item.estado !== null) {
      this.permisosExpedienteService.cambiarEstadoPermisoExpediente(
        eventoAccion ? item.item.idPermiso : item.idPermiso,
        this.userData.idUsuario!
      ).subscribe({
        next: ()=>{
          this.alertamodalService.exito(this.tableText['exito']);
        },
        error: (error)=>{
          this.alertamodalService.error(this.tableText['exito']);
        },
      });
    } else {
      this.alertamodalService.error(this.tableText['seleccionar']);
    }
  }

  onChangeInfoUsuario(event: FormGroup){
    this.fieldsInfoUsuarioBusquedaFormGroup = event
  }

  asignarPermiso(event: FormGroup){
    this.fieldsGestionPermisosFormGroup = event
    this.permisosExpedienteService.asignarPermisosExpediente({
      idUsuario: this.idUsuarioBusqueda!,
      idExpediente: this.idExpediente!,
      estado: event.value.estado
    }).subscribe({
      next: ()=>{
        this.alertamodalService.alertaAccion("exito", "", `Permiso asignado correctamente`, () =>{
          this.clearForms()
          this.creacionFormulario();
          this.consultarUsuarioAsignados()
        }, () =>{
          this.clearForms()
        })
      },
      error: (error) =>{
        this.alertamodalService.alertaAccion("error", "Error asignando Permisos", "No se pudo asignar el permiso, por favor intenta de nuevo", () =>{
          this.clearForms()
        }, () =>{
          this.clearForms()
        })
      }
    })
  }

  clearForms(){
    this.fieldsBusquedaPorCedulaFormGroup?.reset()
    this.fieldsGestionPermisosFormGroup?.reset()
    this.fieldsInfoUsuarioBusquedaFormGroup?.reset()
  }

  consultarUsuarioAsignados(){
    this.permisosExpedienteService.consultarUsuarioAsignados(this.idExpediente!).subscribe({
      next: (resp)=>{

        this.usuariosAsignados = resp.data ? resp.data:[]
      },
      error: (error)=>{
      }
    })
  }
}
